<div class="flex flex-col gap-2">
  <soft-input
    icon="fa-regular fa-search"
    type="text"
    [placeholder]="'Nach '+ title() + ' suchen'"
    [value]="search() ?? ''"
    (valueChange)="search.set($event)"
  />

  <div class="flex flex-col gap-1 max-h-[60vh] overflow-auto p-1">
    @for (participant of filteredParticipants(); track participant.id) {
    <button
      type="button"
      class="flex items-center gap-3 w-full rounded-lg border-2 bg-surface px-3 py-2 text-left transition-all cursor-pointer shrink-0"
      [class]="
          isSelected(participant.id)
            ? 'border-primary shadow-sm'
            : 'border-transparent hover:bg-hover'
        "
      (click)="toggleParticipant(participant.id)"
    >
      <span class="flex-1 text-sm font-medium">{{ participant.name }}</span>
      <soft-ds-icon
        class="shrink-0"
        [name]="isSelected(participant.id) ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"
        [color]="isSelected(participant.id) ? 'brand' : 'disabled'"
      />
    </button>
    } @empty {
    <p class="text-sm text-secondary p-2">{{'Keine '+ title()+ ' gefunden.'}}</p>
    }
  </div>

  <div class="flex justify-end gap-2 pt-2">
    <soft-ds-button variant="outline" (click)="resolve(null)">Abbrechen</soft-ds-button>
    <soft-ds-button variant="primary" (click)="resolveModal()">
      <ng-template softSlot="leading">
        <soft-ds-icon name="fa-solid fa-check" />
      </ng-template>
      {{title()}} übernehmen
    </soft-ds-button>
  </div>
</div>
